<template>
  <div v-if="this.type == 'aircon'">
    <Aircon
      v-if="this.calldata[0]"
      :calldata="this.calldata"
      :type="this.type"
      :sensorid="this.sensorid"
    />
  </div>
  <div v-else-if="this.type == 'relay'">
    <Relay :type="this.type" />
  </div>
  <div v-else>
    <vs-breadcrumb>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'IndoorTag'" title="Device">Tag</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Tag</li>
    </vs-breadcrumb>
    <vs-row vs-w="12" v-if="this.username != 'poonsak.ngk'">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <div class="mt-2" slot="header">
            <h4>
              {{ sensorname }}
            </h4>
          </div>
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              class="p-3"
              vs-sm="4"
              vs-xs="4"
            >
              <vs-avatar
                v-if="srcImg.lenght > 0"
                src="../../../assets/images/users/5.jpg"
                size="140px"
              />
              <vs-avatar v-else :src="srcImg" size="140px" />
              <!-- <vs-button
                color="primary"
                type="border"
                icon="edit"
                >Edit Image</vs-button
              > -->

              <CropImg :nameFile="this.sensorname" :mac="this.macname" />
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-align="center"
              vs-lg="7"
              vs-sm="7"
              vs-xs="8"
            >
              <div style="width: 100%">
                <vs-row vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <!-- <vs-icon color="green" class icon="edit" size="12px" ></vs-icon> -->

                    <span class="font-weight-bold">Name</span>

                    <v-icon aria-hidden="false"> </v-icon>

                    <b-modal
                      id="addsensor"
                      :no-close-on-backdrop="false"
                      hide-header-close
                      centered
                      hide-footer
                      size="lg"
                    >
                      <template #modal-title>
                        <h4 class="textSuccess">Edit Device</h4>
                      </template>
                      <div>
                        <AddDevice
                          :mac="this.macname"
                          :typed="this.type"
                          :sensorname="this.sensorname"
                        />
                      </div>
                    </b-modal>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span class="mr-2">{{ sensorname }}</span>
                    <!-- --------------------------------- ICON ------------------------- -->

                    <vs-icon
                      icon="edit"
                      color="primary"
                      size="18px"
                      v-b-modal.addsensor
                    ></vs-icon>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold textNowrap">Mac Address</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ macname }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Type</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ type }}</span>
                  </vs-col>
                </vs-row>
                <!-- <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Location</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ nwname }}</span>
                  </vs-col>
                </vs-row> -->
                <vs-row
                  v-if="statussensor || type == 'control'"
                  class="mt-3"
                  vs-w="12"
                >
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Status</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>Active</span>
                  </vs-col>
                </vs-row>
                <vs-row v-else class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Status</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{indoorstate}}</span>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- <vs-card >
      <h4 class="card-title d-flex">Control Status</h4>
    </vs-card>

    <vs-row v-if="this.type == 'control'">
      <Control
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :gid="this.gatewayid"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-row> -->

    <!-- <vs-button type="filled" icon="keyboard_backspace" color="#333f50" @click="back()">Back</vs-button> -->

    <!-- <vs-col vs-lg="6" vs-xs="12">
      <AlertState v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-col> -->
    <vs-col vs-lg="12" vs-xs="12">
      <Lastest
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :calldata="this.calldata"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-col>

    <vs-row vs-w="12">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <vs-row id="center">
            <vs-list-header
              title="Tag Data History"
              style="font-size: 18px"
              color="dark"
            ></vs-list-header>
            <vs-spacer />
            <vs-button
              radius
              class="mr-2"
              color="#333f50"
              type="flat"
              @click="exportXLSX"
              icon="cloud_download"
              align="right"
            ></vs-button>
            <vs-button
              radius
              class="mr-2"
              color="#333f50"
              type="flat"
              @click="exportPDF"
              icon="picture_as_pdf"
            ></vs-button>
          </vs-row>

          <vs-tabs v-if="this.username != 'poonsak.ngk'">
            <vs-tab label="History Log">
              <div class="con-tab-ejemplo mt-4">
                <!-- <State
                  v-if="this.calldata[0]"
                  :name="this.sensorname"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :nwid="this.nwid"
                  :nwname="this.nwname"
                  :type="this.type"
                /> -->
                <vs-table :data="dataLog" max-items="5" pagination>
                  <template slot="thead">
                    <vs-th sortKey="name"> Date </vs-th>
                    <vs-th> First Check in </vs-th>
                    <vs-th> Last Check in </vs-th>
                    <vs-th> Man Hour </vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].date">
                        {{ data[indextr].date }}
                      </vs-td>
                      <vs-td
                        :data="data[indextr].firstdate"
                        style="padding: 30px"
                      >
                        {{ data[indextr].firstdate }}
                      </vs-td>
                      <vs-td
                        :data="data[indextr].lastdate"
                        style="padding: 30px"
                      >
                        {{ data[indextr].lastdate }}
                      </vs-td>

                      <vs-td
                        :data="data[indextr].manhour"
                        style="padding: 40px"
                      >
                        {{ data[indextr].manhour }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-tab>

            <vs-tab label="Man Hour Chart Data">
              <div class="con-tab-ejemplo mt-4" ref="pdf">
                <!-- <Data
                  v-if="this.calldata[0]"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :type="this.type"
                  :gid="this.gatewayid"
                  :lora="this.lora"
                /> -->
                <ReportChart :datalog="this.dataLog" />
              </div>
            </vs-tab>
            <!-- <vs-tab label="Alert">
              <div class="con-tab-ejemplo mt-4">
                <vs-row>
                  <vs-col>
                    <vs-row class="mb-4 mt-1">
                      <h4>Alert</h4>
                    </vs-row>
                    <div class="table-responsive ">
                      <vs-table :data="alertlistdata" style="color: #333f50">
                        <template slot="thead">
                          <vs-th
                            id="noWrap"
                            v-for="(head, indexh) in alertheaderlist"
                            :key="indexh"
                            sort-key="alertname"
                          >
                            {{ head }}
                             <span
                          ><vs-icon icon="unfold_more" size="13px"></vs-icon
                        ></span>
                          </vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            id="fontSizeData"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                          >
                            <vs-td>
                              {{ data[indextr].alertname }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].condition }}
                             
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].sensorname }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].date }}
                            </vs-td>
                            <vs-td>
                              <span v-if="data[indextr].status == true"
                                >Active</span
                              >
                              <span v-if="data[indextr].status == false"
                                >Deactive</span
                              >
                            </vs-td>
                            <vs-td>
                              <p
                                v-for="(item, i) in Object.keys(
                                  data[indextr].ReadingData
                                )"
                                :key="i"
                              >
                                <template
                                  v-if="
                                    item != 'date' &&
                                    item != 't' &&
                                    item != 'time' &&
                                    item != 'timestamp' &&
                                    item != 'rssi'
                                  "
                                >
                                  {{ item }}:
                                  {{ data[indextr].ReadingData[item] }}
                                </template>
                              </p>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </vs-col>
                </vs-row>
              
                
              </div>
            </vs-tab> -->
          </vs-tabs>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import Data from "../dashboard/Sensor/Data";
import State from "../dashboard/Sensor/State";
import Control from "../dashboard/Sensor/Control";
import Lastest from "../dashboard/Sensor/Lastest";
import Aircon from "../dashboard/Sensor/Aircon.vue";
import Relay from "../dashboard/Sensor/Relay.vue";
import AddDevice from "../Page/Subpage/editTag.vue";
import ReportChart from "../Page/IndoorTracking/components/ReportChart.vue";
import moment from "moment";

import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

// crop img
import CropImg from "@/views/components/dashboard/syntec/components/CropImg.vue";

export default {
  name: "SensorDashboard",
  props: ["name", "mode"],
  components: {
    Aircon,
    Relay,
    Data,
    State,
    Control,
    Lastest,
    AddDevice,
    ReportChart,
    CropImg,
  },
  data: () => ({
    nwid: "",
    alertlog: "",
    nwname: "",
    username: "",
    indoorstate: "",
    sensorname: "",
    macname: "",
    statussensor: "",
    sensorid: "",
    gatewayid: "",
    idsensor: "",
    token: "",
    type: "",
    fan: "",
    condata: [],
    temp: 0,
    alertlistdata: [],
    alertheaderlist: [
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Alert Timestamp",
      "Status",
      "Reading Data",
    ],
    options1: ["Min", "Low", "Medium", "High", "Max", "Auto"],
    options2: ["Off", "Auto", "Cool", "Heat", "Dry", "Fan"],
    airmode: "",
    random: [],
    random2: [],
    calldata: [],
    count: [],
    sensdata: [{}],
    maxcount: 0,
    lora: "",
    dataTpr: [],
    dataLog: [],
    image: "",
    srcImg: "",
  }),
  computed: {
    //     srcImg:{
    //       get:()=>{
    // re
    //     },
    //     set:()=>{
    //     }
    //     }
  },
  methods: {
    Test() {
      this.State += 1;
    },
    back() {
      this.$router.push({
        name: "ViewNetwork",
        params: {
          name: this.nwname,
          id: this.nwid,
        },
      });
    },
    Max(num) {
      if (this.maxcount <= num) this.maxcount = num;
    },
    getTagLog() {
      this.dataLog = [];
      this.$API.get("indoortaglog/" + this.macname).then((result) => {
        // console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          //  console.log(obj.manhour);
          if (obj.manhour != null) {
            let payload = {
              firstdate: moment(obj.firstdate).format("LTS"),
              lastdate: moment(obj.lastdate).format("LTS"),
              manhour: obj.manhour,
              date: moment(obj.date).format("l"),
            };
            this.dataLog.push(payload);
            payload = {};
            // console.log(this.dataLog);
          }
        }
      });
      // setTimeout(() => {
      //     this.dataLog=this.dataTpr;
      //     console.log(this.dataLog);
      //   }, 100);
    },

    exportXLSX() {
      console.log(this.dataLog)
      const dataWS = XLSX.utils.json_to_sheet(this.dataLog);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "DoorSensor_export.xlsx");
    },
    exportPDF() {
      let pdfRef = this.$refs.pdf;
      html2canvas(pdfRef).then((canvas) => {
        let pdfImage = canvas.toDataURL();

        let pdf = new jsPDF();
        pdf.addImage(pdfImage, "PNG", 0, 20, 200, 100);
        pdf.save(this.sensorname + " export.pdf");
      });
    },
    getImg(nameFile) {
      this.$API.get("download/" + nameFile).then((res) => {
        // console.log("img file", res);
        this.srcImg = res.config.url;
      });
    },
  },

  created() {
    this.macname = this.$session.get("macname");
    //  console.log(this.dataLog)
  },
  //  link3() {
  //     // this.$session.set('nwname',this.network)

  //     // this.$session.set("statussensor", item.active);
  //     // this.$session.set("nwid", item.nwid);
  //     // this.$session.set("sensorname", item.name);
  //     // this.$session.set("sensorid", item.serial_id);
  //     // this.$session.set("gatewayid", item.gatewayid);
  //     // this.$session.set("type", item.type);
  //     // this.$session.set("lora", item.lora);
  //     // this.$session.set("idsensor", this.findID(item));
  //     // console.log(this.network,item) .macname .type
  //     this.$session.set("sensorname", item.name);
  //     this.$session.set("macname", item.macname);
  //     this.$session.set("type", item.type);

  //     v-b-modal.addsensor

  //     // console.log(this.network,item)
  //     // this.$router.push({
  //     //   name: "editTag",
  //     //   params: {
  //     //     sensorname: this.name,
  //     //   },
  //     // });

  //   },
  mounted() {
    this.nwname = this.$session.get("nwname");
    this.nwid = this.$session.get("nwid");
    this.sensorname = this.$session.get("sensorname");
    this.macname = this.$session.get("macname");
    this.indoorstate = this.$session.get("active_status");
    this.sensorid = this.$session.get("sensorid");
    this.gatewayid = this.$session.get("gatewayid");
    this.statussensor = this.$session.get("statussensor");
    this.type = this.$session.get("type");
    this.image = this.$session.get("image");
    this.lora = this.$session.get("lora");
    this.idsensor = this.$session.get("idsensor");
    this.username = this.$session.get("username");
    this.token = this.$session.get("token");
    console.log(
      // this.nwname,
      // this.nwid,
      // this.sensorid,
      // this.gatewayid,
      // this.type,
      // this.lora,
      // this.sensorname,
      // this.username,
      // this.mode
      this.macname,
      this.image
    );
    this.getImg(this.image);

    this.$API.get("alertlog/user").then((alertlog) => {
      // console.log(alertlog.data);
      this.$API
        .get("findid/" + this.sensorname + "/" + this.sensorid)
        .then((result) => {
          this.$API
            .get("alertlog/user/sensor/" + result.data[0].id)
            .then((sensorlog) => {
              // console.log(sensorlog.data);
              sensorlog.data.forEach((elSen) => {
                alertlog.data.forEach((elAlert, i) => {
                  if (elSen.sensorname == elAlert.sensorname) {
                    elAlert.alerthistory.forEach((history) => {
                      if (history.alertstatus) {
                        this.alertlistdata.push({
                          alertname: alertlog.data[i].alertname,
                          condition: history.message,
                          date: this.$moment(history.timestamp).format(
                            "YYYY-MM-DD HH:mm:ss"
                          ),
                          sensorname: alertlog.data[i].sensorname,
                          ReadingData: history.lastdata[0],
                          status: history.alertstatus,
                        });
                      }
                    });
                    // this.condata = element.con;
                    // console.log(this.condata[0])
                  }
                });
              });
            });
        })
        .catch((err) => {
          // console.log(err);
        });
    });
    if (this.mode == 1) {
      if (this.type != "aircon") this.$vs.loading();
      this.$API
        .post("sensorname", {
          name: this.name,
        })
        .then((result) => {
          this.calldata = result.data;
          // :id="this.sensorid" :calldata="this.calldata" :type="this.type" :gid="this.gatewayid"
          this.sensorid = this.calldata[0].sensorid;
          // this.type = 'monnit'
          this.gatewayid = this.calldata[0].gatewayid;
          // console.log(this.sensorid,this.type,this.gatewayid,this.calldata,this.lora)
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        });
    } else {
      // console.log("sensordatashort/" + this.sensorid + "/" + this.gatewayid);
      this.$API
        .get("sensordatashort/" + this.sensorid + "/" + this.gatewayid)
        .then((result) => {
          // conso/le.log(result.data);
          this.calldata = result.data;
          if (this.type == "aircon") {
            this.temp = this.calldata[0].temp;
            this.fan = this.calldata[0].fan;
            this.airmode = this.calldata[0].mode;
          }
          if (this.type == "advantech" || this.type == "ssc") {
            this.calldata.forEach((element) => {
              // // console.log(element.t)
              element.Timestamp = this.$moment(element.t).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              delete element.t;
              delete element.q;
              delete element.c;
              delete element.s;
            });
          }
          this.calldata.forEach((element) => {
            delete element.users_id;
          });
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        })
        .catch((err) => {
          // console.log(err);
        });
    }
    this.getTagLog();
    //  setInterval(() => {
    //    this.getTagLog()
    //   }, 10000)
  },
};
</script>
<style scoped>
.cssTable {
  border-radius: 20px;
  background-color: #f2f3f4;
}
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
img {
  max-width: 100%;
  height: auto;
}

.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>

